<app-resources-section
    class="resources-section"
    [resources]="collection.resources"
    [page]="currentPage"
>
</app-resources-section>
<div class="buttons">
    <app-button
        class="see-less"
        buttonClasses="gtm-collection-page-select selenium-collection-page-first"
        [gtmLabel]="currentPage"
        (click)="!collection.isLoadingResources && seeLess()"
        *ngIf="canSeeLess()"
        [disable]="collection.isLoadingResources"
    >
        <span><app-icon [type]="'Arrow-left'"></app-icon></span>
    </app-button>
    <app-button
        *ngFor="let page of collection.resources; let i = index"
        [gtmLabel]="i"
        [disable]="collection.isLoadingResources || i === currentPage"
        class="numbers"
        buttonClasses="gtm-collection-page-select selenium-collection-page-number"
        (click)="goToPage(i)"
    >
        {{ i + 1 }}
    </app-button>
    <app-button
        class="see-more"
        buttonClasses="gtm-collection-page-select selenium-collection-page-last"
        [gtmLabel]="currentPage + 2"
        (click)="!collection.isLoadingResources && seeMore()"
        *ngIf="canSeeMore()"
        [disable]="collection.isLoadingResources"
    >
        <span><app-icon [type]="'Arrow-right'"></app-icon></span>
    </app-button>
</div>
